// Default import: lz-string is CommonJS, and Node's ESM loader (Playwright) sees no named exports.
import LZString from 'lz-string';

const PREFIX = 'p=';

/** `#p=<lz-string>`: the pattern travels in the URL fragment, which browsers never send to a server. */
export function encodeShareHash(text: string): string {
  return `#${PREFIX}${LZString.compressToEncodedURIComponent(text)}`;
}

/** Returns the pattern text from a `#p=...` hash, or null when absent or corrupt. */
export function decodeShareHash(hash: string): string | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const param = raw.split('&').find((part) => part.startsWith(PREFIX));
  if (!param) return null;
  const payload = param.slice(PREFIX.length);
  if (!payload) return null;
  try {
    const text = LZString.decompressFromEncodedURIComponent(payload);
    return typeof text === 'string' && text.length > 0 ? text : null;
  } catch {
    return null;
  }
}

export function shareUrl(text: string, location: Pick<Location, 'origin' | 'pathname' | 'search'>): string {
  return `${location.origin}${location.pathname}${location.search}${encodeShareHash(text)}`;
}
